import { Pagination, Table, type TableColumn } from "@maeiz/ui";
import { DocPage, Section, Demo, SpecTable } from "../../components/DocChrome";

type Row = { id: string; name: string; bottles: number };

const columns: TableColumn<Row>[] = [
    { key: "name", header: "Customer", render: (r) => r.name },
    { key: "bottles", header: "Bottles", className: "text-end", render: (r) => r.bottles },
];

const data: Row[] = [
    { id: "1", name: "Al-Noor Traders", bottles: 24 },
    { id: "2", name: "City Villa", bottles: 8 },
];

export function TablesPage() {
    return (
        <DocPage
            title="Tables & Data"
            description="Operational data is first-class. Prefer Table + Pagination from @maeiz/ui."
        >
            <Section title="How it looks">
                <Demo>
                    <Table columns={columns} data={data} />
                    <div className="mt-4">
                        <Pagination currentPage={1} totalPages={4} onPageChange={() => undefined} />
                    </div>
                </Demo>
            </Section>
            <Section title="Rules">
                <SpecTable
                    rows={[
                        [
                            "Density",
                            "Comfortable row height; numerical columns tabular-nums + end-aligned",
                        ],
                        ["Empty", "Use EmptyState inside table region"],
                        ["Loading", "Table isLoading skeleton rows"],
                        ["Responsive", "Horizontal scroll on small screens"],
                        ["Bulk actions", "Appear only when selection > 0"],
                    ]}
                />
            </Section>
        </DocPage>
    );
}
